import script from "./BrandsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandsTable.vue?vue&type=script&setup=true&lang=ts"

import "./BrandsTable.vue?vue&type=style&index=0&id=2be42826&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be42826"]])

export default __exports__